import React from 'react';

const MenuThemeContext = React.createContext(null);

export default MenuThemeContext;